module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    style: ('width:880px;margin:10px auto;padding:20px;background-color:' + _vm.value.backgroundColor.hex + ';')
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "flex": "1"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.quote),
      expression: "value.quote"
    }],
    staticStyle: {
      "width": "100%",
      "height": "120px"
    },
    attrs: {
      "placeholder": "Enter a quote..."
    },
    domProps: {
      "value": (_vm.value.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "quote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('slider-picker', {
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    },
    model: {
      value: (_vm.value.backgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.value, "backgroundColor", $$v)
      },
      expression: "value.backgroundColor"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.backgroundColor.hex),
      expression: "value.backgroundColor.hex"
    }],
    attrs: {
      "placeholder": "Hex colour"
    },
    domProps: {
      "value": (_vm.value.backgroundColor.hex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value.backgroundColor, "hex", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "3"
    }
  }, [_c('froala-editor', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "min-height": "100%"
    },
    model: {
      value: (_vm.value.wysiwyg),
      callback: function($$v) {
        _vm.$set(_vm.value, "wysiwyg", $$v)
      },
      expression: "value.wysiwyg"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9687d02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleWidgets/FeaturedQuote.vue
// module id = 680
// module chunks = 1